export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "delivery_item": {
            "self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Item"])},
            "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad"])},
            "unit_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio unitario"])},
            "total_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio total"])},
            "delivery_product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producto"])},
            "delivery": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrega"])},
            "delivery_collection_item": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Origen"])},
            "order_item": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pedido"])}
          }
        }
      }
    }
  })
}